import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-integracao',
  templateUrl: './contratos-integracao.component.html',
  styleUrl: './contratos-integracao.component.css'
})
export class ContratosIntegracaoComponent {

}
